import React from 'react';
import { asyncComponent } from '@jaredpalmer/after';
var routes = [
    {
        path: '/',
        exact: true,
        component: asyncComponent({
            chunkName: 'home',
            loader: function () { return import('pages/home/Home'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/tech',
        exact: true,
        component: asyncComponent({
            chunkName: 'tech',
            loader: function () { return import('pages/tech/Tech'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/media',
        exact: true,
        component: asyncComponent({
            chunkName: 'media',
            loader: function () { return import('pages/media/Media'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/works',
        exact: true,
        component: asyncComponent({
            chunkName: 'tech',
            loader: function () { return import('pages/works/Works'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/services',
        exact: true,
        component: asyncComponent({
            chunkName: 'tech',
            loader: function () { return import('pages/services/Services'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/aboutus',
        exact: true,
        component: asyncComponent({
            chunkName: 'tech',
            loader: function () { return import('pages/aboutus/AboutUs'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/mrestate-info',
        exact: true,
        component: asyncComponent({
            chunkName: 'intro',
            loader: function () { return import('pages/mrEstate/mrEstateInfo/MrEstateInfo'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/mrestate-intro',
        exact: true,
        component: asyncComponent({
            chunkName: 'mrestate',
            loader: function () { return import('pages/mrEstate/mrEstateIntro/MrEstateIntro'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/mrestate-features',
        exact: true,
        component: asyncComponent({
            chunkName: 'mrestate',
            loader: function () { return import('pages/mrEstate/mrEstateFeatures/MrEstateFeatures'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/mrestate-monetization',
        exact: true,
        component: asyncComponent({
            chunkName: 'mrestate',
            loader: function () { return import('pages/mrEstate/mrEstateMonetization/Monetization'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/:lang?',
        exact: true,
        component: asyncComponent({
            chunkName: 'home',
            loader: function () { return import('pages/home/Home'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/:lang?/tech',
        exact: true,
        component: asyncComponent({
            chunkName: 'tech',
            loader: function () { return import('pages/tech/Tech'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/:lang?/media',
        exact: true,
        component: asyncComponent({
            chunkName: 'media',
            loader: function () { return import('pages/media/Media'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/:lang?/works',
        exact: true,
        component: asyncComponent({
            chunkName: 'tech',
            loader: function () { return import('pages/works/Works'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/:lang?/services',
        exact: true,
        component: asyncComponent({
            chunkName: 'tech',
            loader: function () { return import('pages/services/Services'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/:lang?/aboutus',
        exact: true,
        component: asyncComponent({
            chunkName: 'tech',
            loader: function () { return import('pages/aboutus/AboutUs'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/:lang?/mrestate-info',
        exact: true,
        component: asyncComponent({
            chunkName: 'mrestate',
            loader: function () { return import('pages/mrEstate/mrEstateInfo/MrEstateInfo'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/:lang?/mrestate-intro',
        exact: true,
        component: asyncComponent({
            chunkName: 'mrestate',
            loader: function () { return import('pages/mrEstate/mrEstateIntro/MrEstateIntro'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/:lang?/mrestate-features',
        exact: true,
        component: asyncComponent({
            chunkName: 'mrestate',
            loader: function () { return import('pages/mrEstate/mrEstateFeatures/MrEstateFeatures'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        path: '/:lang?/mrestate-monetization',
        exact: true,
        component: asyncComponent({
            chunkName: 'mrestate',
            loader: function () { return import('pages/mrEstate/mrEstateMonetization/Monetization'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
    {
        component: asyncComponent({
            chunkName: 'notFound',
            loader: function () { return import('pages/notFound/NotFound'); },
            Placeholder: function () { return React.createElement("div", null, "...LOADING..."); },
        }),
    },
];
export default routes;
